export const BASE_API_URL = "https://exercism.org/api/v2";
